export class LogbookDataService {
    public static acknowledgeLogbookItem(logbookItemId: string,callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/logbook/${logbookItemId}/acknowledge`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}